import Logger from '@/lib/logger';
import { NEXT_PUBLIC_SIGNUP_ATTRIBUTION_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('SignupAttribution', 'DEBUG');

if (NEXT_PUBLIC_SIGNUP_ATTRIBUTION_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
